// extracted by mini-css-extract-plugin
module.exports = {"button":"by_cQ","primary":"by_cW by_cQ","secondary":"by_cX by_cQ","dark":"by_b by_cQ","ghost":"by_d8 by_cQ","block":"by_cY","fluid":"by_cZ"};